import Layout from '../../components/Layout';
import ConseillerDashboard from '../../components/conseiller/ConseillerDashboard';

export default function CpDashboard() {
  return (
    <Layout title="Tableau de bord — Conseiller pédagogique">
      <ConseillerDashboard showInlineLogout={false} />
    </Layout>
  );
}
